module.exports = "/assets/data/d97b0eca10a12ee5004dab1502e686f9-L15.data.json";